// src/constants.js
export const countryCodes = [
    { code: '+91', country: 'India' },
    { code: '+1', country: 'USA/Canada' },
    { code: '+44', country: 'United Kingdom' },
    { code: '+61', country: 'Australia' },
    { code: '+33', country: 'France' },
    { code: '+81', country: 'Japan' },
  ];